import Swal from "sweetalert2";
import util from "@/mixins/util";
import store from "@/store";
import {checkAccessPermission} from "@/mixins/permission";
const Access = {
    DETAIL: "detail",
    DELETE: "delete",
    EXCEL: 'excel',
    WRITE: "write",
    LIST: 'list',
}

let checkAccessPage = function (accessIdx = '', openAlert = true) {
    ///권한 임시로 모두 해제
    // return {status: true, route: '/'};
    if (accessIdx == '' || !accessIdx) {
        return {status: true, route: '/myinfo'};
    }
    let userInfo = store.getters['userInfo/getUserInfo'];


    if (userInfo.cmsAuthority !== undefined) {


        if (userInfo.cmsAuthority.isSuper === 1) {
            return {status: true, route: '/'};
        }
        //todo 나중에 꼭 지울것 - 임시 해당 계정들만 허용
        let lgAccess = ['content_lg_list', 'content_lg_list_view', 'content_lg_list_update', 'content_lg_list_alldelete'];
        if(lgAccess.indexOf(accessIdx) > -1 && (userInfo.mbId == 'mini0000@cmb.co.kr' || userInfo.mbId == 'yunaadm1@hamagroups.io')) {
            return {status: true, route: '/'};
        }

        if (util.isEmpty(userInfo) || userInfo.cmsAuthority.isSuper === 0 && (util.isEmpty(userInfo.cmsAuthority) || userInfo.cmsAuthority.cmsAccess !== 1)) {

            if (openAlert) {
                Swal.fire({
                    title: '접근',
                    html: '접근 권한이 없습니다.',
                    confirmButtonText: '닫기',
                    customClass: 'alert-default',
                })
            }

            return {status: false, route: "/auth"};
        }

        let adminAuthorities = userInfo.cmsAuthority.menu.slice();

        if (util.isEmpty(adminAuthorities.filter(aa => aa.cadIdx == accessIdx || aa.cadRoute == accessIdx))) {
            if (openAlert) {
                Swal.fire({
                    title: '접근',
                    html: '접근 권한이 없습니다. ',
                    confirmButtonText: '닫기',
                    customClass: 'alert-default',
                })
            }
            let data = {
                status: false,
                route: '/myinfo'
            };
            return data;
        }
        //Merge
        return {status: true, route: '/'};
    }
    return {status: true, route: '/'};
}


let checkAccessPageRoute = function (accessRoute = '', openAlert = true) {
    ///권한 임시로 모두 해제
    // return {status: true, route: '/'};

    if (accessRoute == '') {
        return {status: true, route: '/myinfo'};
    }
    let userInfo = store.getters['userInfo/getUserInfo'];
    if (util.isEmpty(userInfo) || userInfo.cmsAuthority.isSuper === 0 && (util.isEmpty(userInfo.cmsAuthority) || userInfo.cmsAuthority.cmsAccess !== 1)) {
        if (openAlert) {
            Swal.fire({
                title: '접근',
                html: '접근 권한이 없습니다.',
                confirmButtonText: '닫기',
                customClass: 'alert-default',
            })
        }
        return {status: false, route: "/auth"};
    }
    if (userInfo.cmsAuthority.isSuper) {
        return {status: true, route: '/'};
    }

    let permitted = checkAccessPermission(accessRoute);
    if (!permitted) {
        if (openAlert) {
            Swal.fire({
                title: '접근',
                html: '접근 권한이 없습니다.',
                confirmButtonText: '닫기',
                customClass: 'alert-default',
            })
        }
        return {
            status: false,
            route: '/myinfo'
        };
    }

    return {status: true, route: '/'};
}


export {checkAccessPage, checkAccessPageRoute,Access}




